/* MKB 2026 — Kit builder, part 3 of 5 (see mkb-builder-1.js). */
(function (K) {
  'use strict';
  var ORD = K.ORD, COLORS = K.COLORS, KITE_PTS = K.KITE_PTS, BOARD_PTS = K.BOARD_PTS, WAIST_TXT = K.WAIST_TXT, STRAP_TXT = K.STRAP_TXT, GUIDES = K.GUIDES, COPY = K.COPY, LABEL = K.LABEL, ROLE = K.ROLE;
  var esc = K.esc, uniq = K.uniq, first = K.first, clone = K.clone, num = K.num, ordOf = K.ordOf, interp = K.interp, sized = K.sized, swatch = K.swatch, round1 = K.round1, article = K.article;
  var Builder = K.Builder;

  Builder.prototype.fitText = function (sl) {
    var s = this.st[sl.key], r = this.rec(sl), p = this.P[s.h];
    var t = this.fitBase(sl, s, r, p);
    if (r && s.ideal != null && s.fit !== s.ideal) {
      var want = this.chipMain(sl.kind, p, s.ideal) + (sl.kind === 'board' ? ' cm' : '');
      t += ' <span class="kb-fit__warn">' + esc(want) + ' is sold out online' + (s.fit != null ? ', so we picked the closest we have. Call us and we will check the shop.' : '. Call us and we will check the shop.') + '</span>';
    }
    return t;
  };
  Builder.prototype.fitBase = function (sl, s, r, p) {
    var fit = s.ideal != null ? this.chipMain(sl.kind, p, s.ideal) : null;
    switch (sl.kind) {
      case 'kite':
        if (!r) return 'Add your weight in <button type="button" class="kb-inline" data-act="goto" data-slot="rider">You</button> to see your best fit.';
        if (sl.role === 'single') return 'Best fit for ' + esc(this.weightTxt()) + ': <strong>' + esc(fit || '—') + '</strong>, in 15 to 20 knots.';
        return 'For ' + esc(this.weightTxt()) + ', your ' + ROLE[sl.role].toLowerCase() + ' is about <strong>' + esc(fit || (Math.round(r.ideal) + 'm')) + '</strong>.';
      case 'bar':
        if (!r) return 'Pick your kite size first. The bar follows it.';
        return 'Your ' + r.kite + 'm kite takes a <strong>' + esc(fit || '—') + '</strong> bar.';
      case 'board':
        if (!r) return 'Add your weight in <button type="button" class="kb-inline" data-act="goto" data-slot="rider">You</button> to see your best fit.';
        return 'Best fit for ' + esc(this.weightTxt()) + ': <strong>' + esc(fit ? fit + ' cm' : '—') + '</strong> long.';
      case 'harness':
        if (!r) return 'Add your waist in <button type="button" class="kb-inline" data-act="goto" data-slot="rider">You</button> to see your best fit.';
        return 'Best fit for your waist: <strong>' + esc(fit || '—') + '</strong>.';
      case 'hook':
        if (!r) return 'Pick your harness size first. The hook follows it.';
        return 'A size ' + esc(r.harness) + ' harness takes a <strong>' + esc(fit || '—') + '</strong> hook.';
      case 'straps':
        if (!r) return 'Add your shoe size in <button type="button" class="kb-inline" data-act="goto" data-slot="rider">You</button> to see your best fit.';
        return 'Best fit for your shoe size: <strong>' + esc(fit || '—') + '</strong>.';
    }
    return '';
  };

  /* ---------- totals ---------- */
  Builder.prototype.missing = function (sl) {
    var s = this.st[sl.key], p = this.P[s.h], label = (sl.role && ROLE[sl.role]) || LABEL[sl.kind];
    if (!p) return 'Pick your ' + label.toLowerCase();
    for (var j = 0; j < p.meta.length; j++) {
      var m = p.meta[j];
      if (!m.hidden && s.sel[m.i] == null) return 'Pick your ' + label.toLowerCase() + ' ' + (m.kind === 'color' ? 'color' : 'size');
    }
    return label + ': not in stock in this size';
  };
  Builder.prototype.totals = function () {
    var self = this, T = { total: 0, from: false, ready: 0, need: 0, next: null, lines: [] };
    if (!this.pkg) return T;
    this.slots.forEach(function (sl) {
      var on = self.isOn(sl); if (on !== true) return;
      var s = self.st[sl.key]; T.need++;
      if (s.skip) { T.ready++; T.lines.push({ sl: sl, skip: true }); return; }
      var p = self.P[s.h], v = p ? self.variant(p, s.sel) : null;
      if (v && v.a) { T.ready++; T.total += v.p; T.lines.push({ sl: sl, p: p, v: v }); }
      else { T.from = true; if (p) T.total += self.minGiven(p, s.sel); T.lines.push({ sl: sl, p: p, todo: self.missing(sl) }); if (!T.next) T.next = { key: sl.parent || sl.key, msg: self.missing(sl), slot: sl.key }; }
    });
    this.pkg.addons.concat(this.pkg.lessons).forEach(function (h) {
      var e = self.ex[h]; if (!e || !e.on) return;
      var p = self.P[h], v = self.variant(p, e.sel); T.need++;
      if (v && v.a) { T.ready++; T.total += v.p; T.lines.push({ ex: h, p: p, v: v }); }
      else { T.from = true; T.total += self.minGiven(p, e.sel); T.lines.push({ ex: h, p: p, todo: 'Pick a size' }); if (!T.next) T.next = { key: 'extras', msg: 'Pick a size for ' + self.title(p), slot: 'x-' + h }; }
    });
    return T;
  };
  Builder.prototype.fromPrice = function (k) {
    var self = this, sum = 0;
    function minOf(list) { var a = list.map(function (h) { return self.P[h].min; }); return a.length ? Math.min.apply(null, a) : 0; }
    sum += minOf(k.kites) * k.kiteCount + minOf(k.bars) * k.barCount;
    var hookMin = minOf(k.hooks);
    if (k.harnesses.length) sum += Math.min.apply(null, k.harnesses.map(function (h) { return self.P[h].min + (k.hooks.length && self.hookInc.indexOf(h) < 0 ? hookMin : 0); }));
    sum += minOf(k.boards) + minOf(k.straps) + minOf(k.pumps);
    return sum;
  };

  /* ---------- rendering ---------- */
  Builder.prototype.head = function (c, tag) {
    return '<' + (tag || 'h2') + ' class="kb-step__h">' + esc(c[0]) + ' <span class="kb-soft">' + esc(c[1]) + '</span></' + (tag || 'h2') + '>';
  };
  Builder.prototype.img = function (url, w, alt) {
    if (!url) return '<span class="kb-noimg" aria-hidden="true"></span>';
    return '<img src="' + esc(sized(url, w)) + '" alt="' + esc(alt || '') + '" loading="lazy" decoding="async">';
  };
  Builder.prototype.includes = function (k) {
    var a = [k.kiteCount > 1 ? k.kiteCount + ' kites' : 'Kite', k.barCount > 1 ? k.barCount + ' bars' : 'bar', 'harness', 'board', 'straps', 'pump'];
    return a.join(' · ');
  };

  Builder.prototype.renderPkg = function () {
    var self = this, html = '<section class="kb-step kb-step--pkg" data-step="pkg">' + this.head(COPY.pkg) +
      '<div class="kb-tiles" role="radiogroup" aria-label="Package">';
    this.pkgs.forEach(function (k) {
      var on = self.pkg && self.pkg.id === k.id;
      html += '<button type="button" class="kb-tile kb-tile--pkg" role="radio" aria-checked="' + (on ? 'true' : 'false') + '" data-act="pkg" data-id="' + esc(k.id) + '" data-fk="pkg-' + esc(k.id) + '">' +
        '<span class="kb-tile__txt">' + (k.level ? '<span class="kb-tile__brand">' + esc(k.level) + '</span>' : '') +
        '<span class="kb-tile__name">' + esc(k.title) + '</span>' +
        (k.tagline ? '<span class="kb-tile__note">' + esc(k.tagline) + '</span>' : '') +
        '<span class="kb-tile__inc">' + esc(self.includes(k)) + '</span></span>' +
        '<span class="kb-tile__price"><small>From</small>' + self.money(self.fromPrice(k)) + '</span></button>';
    });
    html += '</div></section>';
    this.els.pkg.innerHTML = html;
  };

  Builder.prototype.renderRider = function () {
    if (this.els.rider.firstChild) return;
    var r = this.rider, id = this.uid;
    function field(f, label, units, ph, step, help) {
      var u = r[f + 'u'];
      return '<div class="kb-field"><label class="kb-field__l" for="' + id + '-' + f + '">' + label + '</label>' +
        '<div class="kb-field__row"><input class="kb-field__in" id="' + id + '-' + f + '" type="number" inputmode="decimal" min="1" step="' + step + '" placeholder="' + ph + '" data-rider="' + f + '" value="' + (r[f] || '') + '" aria-describedby="' + id + '-rnote">' +
        '<span class="kb-seg" role="group" aria-label="' + label + ' unit">' + units.map(function (x) {
          return '<button type="button" data-act="unit" data-f="' + f + '" data-u="' + x[0] + '" aria-pressed="' + (u === x[0] ? 'true' : 'false') + '">' + x[1] + '</button>';
        }).join('') + '</span></div>' + (help ? '<span class="kb-field__h">' + help + '</span>' : '') + '</div>';
    }
    this.els.rider.innerHTML = '<section class="kb-step" data-step="rider">' + this.head(COPY.rider) +
      '<div class="kb-rider">' +
      field('w', 'Your weight', [['lb', 'lbs'], ['kg', 'kg']], r.wu === 'kg' ? '75' : '165', 1, 'Sizes your kite and board') +
      field('x', 'Your waist', [['in', 'in'], ['cm', 'cm']], r.xu === 'cm' ? '86' : '34', 0.5, 'Sizes your harness') +
      field('s', 'Shoe size', [['us', 'US'], ['eu', 'EU']], r.su === 'eu' ? '42' : '9', 0.5, 'Sizes your straps') +
      '</div><p class="kb-note" id="' + id + '-rnote">We use these to pick your sizes below. You can change any of them.</p></section>';
  };

  Builder.prototype.chipMain = function (kind, p, val) {
    var n = num(val), m;
    switch (kind) {
      case 'kite': return isNaN(n) ? val : n + 'm';
      case 'bar': return isNaN(n) ? val : n < 44 ? 'Small' : n < 50 ? 'Medium' : 'Large';
      case 'board': m = String(val).match(/(\d+)\s*x\s*(\d+)/i); return m ? m[1] : val;
      case 'hook': return isNaN(n) ? val : String(n > 100 ? n / 10 : n);
    }
    return val;
  };
  Builder.prototype.chipSub = function (kind, p, val, price, varies) {
    var n = num(val), m, k = String(val).toUpperCase().replace(/\s+/g, '');
    switch (kind) {
      case 'kite': return this.money(price, true);
      case 'bar': return String(val).replace(/\s*cm\s*$/i, '').replace(/\s*-\s*/, '–') + ' cm';
      case 'board': m = String(val).match(/(\d+)\s*x\s*(\d+)/i); return m ? '× ' + m[2] + ' cm' : '';
      case 'harness': return WAIST_TXT[k] || '';
      case 'hook': return isNaN(n) ? '' : (n > 100 ? n : n * 10) + ' mm';
      case 'straps': return STRAP_TXT[k] || '';
    }
    return varies ? this.money(price, true) : '';
  };
  Builder.prototype.optLabel = function (kind, p, s) {
    var self = this;
    return p.meta.filter(function (m) { return !m.hidden && s.sel[m.i] != null; }).map(function (m) {
      var v = s.sel[m.i];
      if (m.i === p.sizeI) { var a = self.chipMain(kind, p, v); return kind === 'board' ? a + ' cm' : (kind === 'hook' ? a + ' hook' : a); }
      return v;
    }).join(' · ');
  };

  Builder.prototype.renderTiles = function (key, list, selH, kind, ex) {
    var self = this, html = '<div class="kb-tiles" role="' + (ex ? 'group' : 'radiogroup') + '" aria-label="' + esc(LABEL[kind] || 'Extras') + '">';
    list.forEach(function (h) {
      var p = self.P[h], on = ex ? !!(self.ex[h] && self.ex[h].on) : selH === h;
      var varies = p.max > p.min;
      var tag = (kind === 'harness' && self.slot('hook') && self.slot('hook').list.length) ? (self.hookInc.indexOf(h) >= 0 ? '<span class="kb-tag">Hook included</span>' : '<span class="kb-tag kb-tag--soft">Hook sold separately</span>') : '';
      html += '<button type="button" class="kb-tile' + (ex ? ' kb-tile--check' : '') + (p.avail ? '' : ' is-out') + '" role="' + (ex ? 'checkbox' : 'radio') + '" aria-checked="' + (on ? 'true' : 'false') + '"' +
        (p.avail ? '' : ' aria-disabled="true"') + ' data-act="' + (ex ? 'extra' : 'prod') + '" data-slot="' + esc(key) + '" data-h="' + esc(h) + '" data-fk="t-' + esc(key) + '-' + esc(h) + '">' +
        '<span class="kb-tile__img">' + self.img(p.img, 240, '') + '</span>' +
        '<span class="kb-tile__txt">' + (p.brand ? '<span class="kb-tile__brand">' + esc(p.brand) + '</span>' : '') +
        '<span class="kb-tile__name">' + esc(self.title(p)) + '</span>' +
        (self.note(p) ? '<span class="kb-tile__note">' + esc(self.note(p)) + '</span>' : '') + tag + '</span>' +
        '<span class="kb-tile__price">' + (p.avail ? (varies ? '<small>From</small>' : '') + self.money(p.min, true) : '<small>Sold out</small>') + '</span>' +
        (ex ? '<span class="kb-check" aria-hidden="true"></span>' : '') + '</button>';
    });
    return html + '</div>';
  };

  Builder.prototype.renderOpts = function (key, kind, p, s, act) {
    var self = this, html = '';
    p.meta.forEach(function (m) {
      if (m.hidden) return;
      var cur = s.sel[m.i];
      if (m.i === p.colorI) {
        html += '<div class="kb-sub"><p class="kb-sub__h"><span>' + esc(m.name) + '</span><span class="kb-sub__v">' + esc(cur || 'Pick one') + '</span></p><div class="kb-sws" role="radiogroup" aria-label="' + esc(m.name) + '">';
        m.vals.forEach(function (val) {
          var ok = self.availWith(p, s.sel, m.i, val), anyOk = self.existsAny(p, m.i, val);
          html += '<button type="button" class="kb-sw' + (ok ? '' : ' is-x') + (anyOk ? '' : ' is-out') + '" role="radio" aria-checked="' + (cur === val ? 'true' : 'false') + '"' + (anyOk ? '' : ' aria-disabled="true"') +
            ' data-act="' + act + '" data-slot="' + esc(key) + '" data-i="' + m.i + '" data-v="' + esc(val) + '" data-fk="o-' + esc(key) + '-' + m.i + '-' + esc(val) + '" aria-label="' + esc(val) + (ok ? '' : anyOk ? ' (not in this size)' : ' (sold out)') + '" title="' + esc(val) + '">' +
            '<span style="background:' + swatch(val) + '"></span></button>';
        });
        html += '</div></div>';
        return;
      }
      var isSize = m.i === p.sizeI, k = isSize ? kind : 'other';
      var prices = m.vals.map(function (val) { return self.priceFor(p, s.sel, m.i, val); });
      var varies = Math.max.apply(null, prices) > Math.min.apply(null, prices);
      html += '<div class="kb-sub"><p class="kb-sub__h"><span>' + esc(isSize ? 'Size' : m.name) + '</span><span class="kb-sub__v">' + esc(cur != null ? self.chipMain(k, p, cur) + (k === 'board' ? ' cm' : '') : 'Pick one') + '</span></p>' +
        '<div class="kb-chips' + (kind === 'kite' && isSize ? ' kb-chips--kite' : '') + '" role="radiogroup" aria-label="' + esc(isSize ? 'Size' : m.name) + '">';
      m.vals.forEach(function (val, j) {
        var ok = self.availWith(p, s.sel, m.i, val), anyOk = self.existsAny(p, m.i, val);
        var sub = anyOk ? (ok ? self.chipSub(k, p, val, prices[j], varies) : 'Other color') : 'Sold out';
        var best = isSize && s.ideal === val;
        html += '<button type="button" class="kb-chip' + (anyOk ? '' : ' is-out') + (ok || !anyOk ? '' : ' is-alt') + (best ? ' is-fit' : '') + '" role="radio" aria-checked="' + (cur === val ? 'true' : 'false') + '"' + (anyOk ? '' : ' aria-disabled="true"') +
          ' data-act="' + act + '" data-slot="' + esc(key) + '" data-i="' + m.i + '" data-v="' + esc(val) + '" data-fk="o-' + esc(key) + '-' + m.i + '-' + esc(val) + '">' +
          (best ? '<span class="kb-chip__badge">Best fit</span>' : '') +
          '<span class="kb-chip__v">' + esc(self.chipMain(k, p, val)) + '</span>' + (sub ? '<span class="kb-chip__s">' + esc(sub) + '</span>' : '') + '</button>';
      });
      html += '</div>';
      if (isSize && act === 'opt') {
        var sl = self.slot(key), ft = sl ? self.fitText(sl) : '';
        if (ft) html += '<p class="kb-fit">' + ft + '</p>';
      }
      html += '</div>';
    });
    return html;
  };
})(window.MKBKB);